import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'app/shared/services/language.service';

@Component({
	selector: 'app-language-switch',
	templateUrl: './language-switch.component.html',
})
export class LanguageSwitchComponent implements OnInit {
	lang: string;
	languages;

	constructor(public languageService: LanguageService) {}

	ngOnInit(): void {
		this.languages = this.languageService.languages;
		this.lang = this.languageService.getLang();
		this.languageService.setLang(this.languageService.getLang());
	}

	switchLanguage(lang: string) {
		this.lang = lang;
		this.languageService.setLang(lang);
	}
}
